export default __webpack_public_path__ + "static/media/Icon-view.143eb9d0.svg";